import styled from 'styled-components';
import { DatePicker } from 'antd';

export const StyledDatePicker = styled(DatePicker.RangePicker)`
    margin-bottom: 0;
    width: 100%;
`;